import {Component, ViewChild} from '@angular/core';

import {Platform, Config} from 'ionic-angular';
import {Nav} from 'ionic-angular';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import {InfoPage} from '../pages/info/info';
import {LoginPage} from '../pages/login/login';
import {DemoPage} from '../pages/demo/demo';
import {SterbefaellePage} from '../pages/sterbefaelle/sterbefaelle';

import {GuiProvider} from '../providers/gui.provider';
import {UserProvider} from '../providers/user.provider';
import {TestsPage} from "../pages/tests/tests";


@Component({
	templateUrl: 'app.html',
})
export class RuheSanftApp {
	@ViewChild(Nav) nav: Nav;

  rootPage : any = SterbefaellePage;
	pages: Array<{title: string, component: any, onlyDemo?: boolean}>;

	constructor(private platform: Platform,
	            private statusBar: StatusBar,
	            private splashScreen: SplashScreen,
	            private guiService: GuiProvider,
	            private userService: UserProvider,
	            private config: Config) {
		this.initializeApp();

		config.set('ios', 'backButtonText', "Zurück");

		this.pages = [
			{ title: 'Sterbefälle', component: SterbefaellePage },
			{ title: 'Anmeldung', component: LoginPage },
			{ title: 'Anleitung', component: InfoPage }
		];

	}

	initializeApp() {
		this.platform.ready().then(() => {
			// Okay, so the platform is ready and our plugins are available.
			// Here you can do any higher level native things you might need.
			this.statusBar.styleDefault();
			this.splashScreen.hide();

			//GUI-Service initialisieren
			this.guiService.init(this.nav);

			//Login über URL-Intent?
			//erst 0-5 sekunden warten, immer wieder versuchen
			//denn handleOpenURL in intenthandler.js wird erst verzögert aufgerufen
			for (let i = 0; i <= 5; i++)
				setTimeout(() => { this.tryLogin(); }, i * 1000);

		});
	}

	tryLogin() {
		let intentUrl = localStorage.getItem("intentUrl");
		if (intentUrl) {
			if (this.userService.loginFromUrl(intentUrl)) {
				localStorage.removeItem("intentUrl");
				this.guiService.showAlert('Anmeldung',
					'Sie wurden mit Ihren Benutzerdaten angemeldet.');
			}
		}
	}

	openPage(page) {
		// Reset the content nav to have just this page
		// we wouldn't want the back button to show in this scenario
		this.nav.setRoot(page.component);
	}

	isMesse() {
		return this.isDebug() || (this.userService.isLoggedIn() && this.userService.user.username == "Messe");
	}

	isDebug() {
		return this.userService.isLoggedIn() && this.userService.user.username == "Debug";
	}

	openDemoPage() {
		this.openPage({ component: DemoPage });
	}

	openTestsPage() {
		this.openPage({ component: TestsPage });
	}

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts